// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__1HqTQ","primary":"styles_primary__zSpJx","active":"styles_active__25enD","disabled":"styles_disabled__2Xnkf","secondary":"styles_secondary__1vK8G"};